<template>
  <v-fab-transition v-if="hidden">
    <v-btn
      v-show="hidden"
      @click="toggleFaqs"
      color="pink"
      dark
      small
      fab
      fixed
    >
      <v-icon>mdi-help</v-icon>
    </v-btn>
  </v-fab-transition>
  <div v-else>
    <div class="d-flex justify-space-between">
      <h2 class="faqs-title">
        <i class="fa fa-question-circle mr-2 font-size-100"></i>{{ title }} FAQs
      </h2>
      <v-fab-transition
        ><v-btn
          v-show="!hidden"
          @click="toggleFaqs"
          color="pink"
          outlined
          fab
          dark
          x-small
        >
          <v-icon class="font-size-50">mdi-arrow-right</v-icon>
        </v-btn></v-fab-transition
      >
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: ["faqs", "title"],
  data() {
    return {
      hidden: false,
    };
  },
  methods: {
    toggleFaqs() {
      this.hidden = !this.hidden;
      this.$emit("toggleForm", this.hidden);
    },
  },
};
</script>

<style lang="scss">
.faqs-title {
  font-size: 1.3rem;
  line-height: 2.5rem;
}
.panel {
  border-radius: 10px;
  margin-bottom: 5px;
  box-shadow: none;
  border: none;
  overflow: hidden;
  backface-visibility: hidden;
  &__header {
    font-size: 0.75rem;
  }
  &__content {
    font-size: 0.75rem;

    padding: 10px 10px 10px 25px;
    &::before {
      content: "";
      border-left: 4px solid #e33065;
    }
  }
}
</style>
